import { render } from "./FileDropArea.vue?vue&type=template&id=481c2cdc&scoped=true"
import script from "./FileDropArea.vue?vue&type=script&lang=js"
export * from "./FileDropArea.vue?vue&type=script&lang=js"

import "./FileDropArea.vue?vue&type=style&index=0&id=481c2cdc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481c2cdc"]])

export default __exports__